/** @jsxImportSource @emotion/react */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Paper,
  Grid,
} from "@mui/material";
import { DtTextInputCpt, FormCpt } from "components/form";
import { useOrganisationService } from "core/hooks";
import { UpdateLicenceCommand } from "core/webapi";
import { useEffect, useState } from "react";

interface UpdateLicenceLimitsDialogFormProps {
  open: boolean;
  close: Function;
  organisation: UpdateLicenceCommand;
}

export const UpdateLicenceLimitsDialogFormCpt = (
  props: UpdateLicenceLimitsDialogFormProps
) => {
  const { open, close, organisation } = props;
  const [internalOpen, setInternalOpen] = useState(open);
  const [model, setModel] = useState(organisation);
  const { updateLicence } = useOrganisationService();

  const handleClose = (result: boolean) => {
    setInternalOpen(false);
    close(result);
  };

  useEffect(() => {
    setInternalOpen(open);
  }, [open]);

  useEffect(() => {
    setModel(organisation);
  }, [organisation]);

  return (
    <>
      <Dialog
        open={internalOpen}
        onClose={() => handleClose(false)}
        PaperComponent={Paper}
        aria-label={`edit licence dialog`}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="dialog-title">Edit licence</DialogTitle>
        <DialogContent>
          <FormCpt
            onSubmit={() => handleClose(true)}
            model={model}
            setModel={setModel}
            submitButtonText="Save"
            submit={updateLicence}
            fullWithButton={false}
            actions={
              <Button
                autoFocus
                onClick={() => handleClose(false)}
                variant="outlined"
                color="secondary"
              >
                Cancel
              </Button>
            }
          >
            <Grid
              container
              spacing={2}
              rowSpacing={2}
              direction="row"
              justifyContent="top"
              alignItems="stretch"
            >
              <Grid xs={12} item>
                <DtTextInputCpt
                  type="number"
                  model={model}
                  setModel={setModel}
                  prop="presentersLimit"
                  label="Presenters limit"
                  fullWidth
                />
              </Grid>
              <Grid xs={12} item>
                <DtTextInputCpt
                  type="number"
                  model={model}
                  setModel={setModel}
                  prop="participantsLimit"
                  label="Participants limit"
                  fullWidth
                />
              </Grid>
            </Grid>
          </FormCpt>
        </DialogContent>
      </Dialog>
    </>
  );
};
